import { useEffect, useState } from 'react';
import { getAllowedTransferItem } from '../model';

export function useIsDragging(): boolean {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    let dragCounter = 0;

    const handleDragEnter = (event: DragEvent) => {
      const dt = event.dataTransfer;
      if (!getAllowedTransferItem(dt)) {
        return;
      }

      dragCounter += 1;
      setIsDragging(true);
    };

    const handleDragOver = (event: DragEvent) => {
      const dt = event.dataTransfer;
      if (!getAllowedTransferItem(dt)) {
        return;
      }

      event.preventDefault();
    };

    const handleDragLeave = (event: DragEvent) => {
      const dt = event.dataTransfer;
      if (!getAllowedTransferItem(dt)) {
        return;
      }

      dragCounter -= 1;
      if (dragCounter <= 0) {
        dragCounter = 0;
        setIsDragging(false);
      }
    };

    const handleDrop = () => {
      dragCounter = 0;
      setIsDragging(false);
    };

    window.addEventListener('dragenter', handleDragEnter);
    window.addEventListener('dragover', handleDragOver);
    window.addEventListener('dragleave', handleDragLeave);
    window.addEventListener('drop', handleDrop);

    return () => {
      window.removeEventListener('dragenter', handleDragEnter);
      window.removeEventListener('dragover', handleDragOver);
      window.removeEventListener('dragleave', handleDragLeave);
      window.removeEventListener('drop', handleDrop);
    };
  }, []);

  return isDragging;
}
